export default __webpack_public_path__ + "static/media/252.920eb816.png";